import { render, staticRenderFns } from "./ReservationManag.vue?vue&type=template&id=134375ce&scoped=true"
import script from "./ReservationManag.vue?vue&type=script&lang=js"
export * from "./ReservationManag.vue?vue&type=script&lang=js"
import style0 from "./ReservationManag.vue?vue&type=style&index=0&id=134375ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134375ce",
  null
  
)

export default component.exports